import { ILocalizable, ILocale } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";
import { IPickerSearchCriterion } from "ui/shared/helpers/plex-components";
import { IIndustry } from "ui/shared/models/common";

export interface ITranslation {
  termId: string;
  translation: string;
  definition: string;
  locale: string;
  industry: string | null;
}

export interface ITermDictionaryEntry {
  term: ITranslation;
  translation: ITranslation;
}

export interface IIndustryPickerSearchCriterion extends IPickerSearchCriterion<IIndustry> {
  localeIdentifier: string;
}

export interface ITermDictionaryFilter {
  modes: ILocalizable[];
  locales: ILocale[];
  industries: IIndustry[];
  localesSearchCriterion?: IPickerSearchCriterion<ILocale>;
}

export interface ITermDictionarySearchQuery {
  locale?: ILocale;
  localeReversed?: boolean;
  industry?: IIndustry;
  keyword?: string;
  bilingual?: boolean;
}

export interface ITermDictionaryState {
  filter: ITermDictionaryFilter;
  searchQuery: ITermDictionarySearchQuery;
  searchResult?: ITermDictionaryEntry[] | ITranslation[];
  selectedRowId: string;
  isLoading: boolean;
  notifications: INotification[];
}

export const getInitialTermDictionaryState = (): ITermDictionaryState => {
  return {
    filter: {
      modes: [{ messageId: glossaryMessages.filter("monolingual") }, { messageId: glossaryMessages.filter("bilingual") }],
      locales: [],
      industries: [],
      localesSearchCriterion: undefined
    },
    searchQuery: {
      locale: undefined,
      localeReversed: false,
      industry: undefined,
      keyword: "",
      bilingual: false
    },
    searchResult: undefined,
    selectedRowId: "",
    isLoading: false,
    notifications: []
  };
};
